import { render, staticRenderFns } from "./ConteudoDash.vue?vue&type=template&id=9a15acc2&scoped=true&"
import script from "./ConteudoDash.vue?vue&type=script&lang=js&"
export * from "./ConteudoDash.vue?vue&type=script&lang=js&"
import style0 from "./ConteudoDash.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ConteudoDash.vue?vue&type=style&index=1&id=9a15acc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a15acc2",
  null
  
)

export default component.exports